import { UseBoundStore } from "zustand";
import { StoreApi } from "zustand/vanilla";
import { useShallow } from "zustand/react/shallow";

export const getOptimizedSelector = <T>(store: UseBoundStore<StoreApi<T>>) => <
  R
>(
  selector: (state: T) => R
) => store(useShallow(selector));
